<script>
 // import StringUtils from '@common/StringUtils'
 // import {EventStatus, ProcedureType, Accommodation} from "@common/status";

 // Baseado no node_modules/vuetify/src/components/VForm/VForm.ts
const DEFAULT_VALUE = null;

export default {
  name: 'FcmGallery',
  components: {},
  provide () {
    return { fcmGalleryList: this };
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [Object],
      default: ()=>{return {};},
    },
    fixOnStart: {
      type: Boolean,
    },
    disableControl: {
      type: Boolean,
    },
  },
  data(vm) {
    return {
      internalLazyValue: vm.updateInternalLazyValue(vm.value, vm.fixOnStart),
      internalErrorMessages: [],
      hasInput: false,
      imageList: [],
      carouselIndexImg: 0,
      carouselShow: false,
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.internalLazyValue;
      },
      set(val) {
        this.updateInternalLazyValue(val, true);
      }
    },
  },
  watch: {
    value(val) {
      this.updateInternalLazyValue(val, this.fixOnStart);
    },
  },
  mounted: async function() {

  },
  beforeDestroy: function() {
  },
  methods: {
    reset () {
      this.hasInput = false;
      this.internalErrorMessages = [];
      this.updateInternalLazyValue(DEFAULT_VALUE, true);
      this.removeFocus();
    },
    resetValidation () {
      this.hasInput = false;
      this.internalErrorMessages = [];
    },
    validate (force=false) {
      this.internalErrorMessages = [];
      for (const rule of this.rules) {
        const result = typeof rule === 'function' ? rule(this.internalLazyValue) : rule;
        if (typeof result === 'string') {
          this.internalErrorMessages.push(result);
        }
      }
      if (force) {
        this.hasInput = true;
      }
      return this.internalErrorMessages.length === 0;
    },
    /**
     * Formato dos dados de saída
     */
    toModel(value) {
      return value;
    },
    removeFocus() {

    },
    /**
     * Alterar esse método para manter a consistência do seu dado interno (internalLazyValue)
     * @param value
     * @param emit
     */
    updateInternalLazyValue(value, emit=false) {
      if(!value) {
        value = DEFAULT_VALUE;
      }
      if(value===DEFAULT_VALUE && this.internalLazyValue===DEFAULT_VALUE) {
        return;
      }
      if (value===DEFAULT_VALUE || this.internalLazyValue===DEFAULT_VALUE || !_.isEqual(this.internalLazyValue, value)) {
        this.resetValidation();
        this.internalLazyValue = value;
        if(emit) {
          this.$emit('input', this.toModel(this.internalLazyValue));
        }
      }
    },

    register(that) {
      this.imageList.push(that);
    },
    unregister(that) {
      const found = this.imageList.find(i => i._uid === that._uid);
      if (!found) return;
      this.imageList = this.imageList.filter(i => i._uid !== found._uid);
    },
    async makeUploadAll(progressFn) {
      if(typeof progressFn!=='function') {progressFn = ()=>{};}
     //  const length = this.imageList.length;

      const length = this.imageList.reduce((a, v)=>{return a+(v.needUpload?1:0)}, 0);
      const promises = [];
      for(const img of this.imageList) {
        if(img.needUpload) {
          img.fcmProgress = 0;
          promises.push(img.makeUpload((p)=> {
            img.fcmProgress = p || 0;
            if(!length) {
              progressFn(1);
            }
            else {
              progressFn(this.imageList.reduce((a, v)=>{return a+(v.needUpload?v.fcmProgress||0:0)}, 0)/length);
            }
          }));
        }
      }
      await Promise.all(promises);
      progressFn(1);
    },
    showCarousel(that = false) {
      let index = 0;
      if(that) {
        index = this.imageList.findIndex(i => i._uid === that._uid);
        if(index===-1) {
          index = 0;
        }
      }
      this.carouselIndexImg = index;
      this.carouselShow = true;
    },
    closeCarousel() {
      this.carouselShow = false;
    },
    removeFile() {
      this.imageList[this.carouselIndexImg]?.removeFile?.();
      this.closeCarousel();
    },
    addFile() {
      this.imageList[this.carouselIndexImg]?.addFile?.();
      this.closeCarousel();
    },
    openInNewTab() {
      this.imageList[this.carouselIndexImg]?.openInNewTab?.();
      this.closeCarousel();
    },
    editFile() {
      this.imageList[this.carouselIndexImg]?.editFile?.();
      this.closeCarousel();
    },
  }
}
</script>


<template>
  <div class="FcmGalleryBox" v-bind="$attrs" v-on="$listeners">
    <VDialog v-model="carouselShow"
             fullscreen
             hide-overlay
             transition="dialog-bottom-transition"
             :content-class="$style.FcmGalleryDialogContent"
    >
      <div class="content">
        <VCarousel v-if="carouselShow" v-model="carouselIndexImg" class="fcmCarousel"
                   height="100%"
        >
          <v-carousel-item v-for="(that, i) in imageList" :key="i" class="fcmCarouselItem"
                           :src="that.dataUrl || null"
                           reverse-transition="fade-transition"
                           transition="fade-transition"
          >
          </v-carousel-item>
        </VCarousel>
        <div class="control">
          <VBtn icon @click="closeCarousel">
            <VIcon>mdi-close</VIcon>
          </VBtn>
          <VBtn v-if="!disableControl" fab elevation="2" x-small @click="removeFile">
            <VIcon>mdi-delete</VIcon>
          </VBtn>
          <VBtn v-if="!disableControl" fab elevation="2" x-small @click="addFile">
            <VIcon>mdi-selection-search</VIcon>
          </VBtn>
          <VBtn v-if="!disableControl" fab elevation="2" x-small @click="openInNewTab">
            <VIcon>mdi-open-in-new</VIcon>
          </VBtn>
          <VBtn v-if="!disableControl" fab elevation="2" x-small @click="editFile">
            <VIcon>mdi-pencil</VIcon>
          </VBtn>
        </div>
      </div>
    </VDialog>
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  // @import '@design';
  .FcmGalleryBox {
    display: flex;
    flex-wrap: wrap;
  }
  .fcmCarouselItem ::v-deep .v-image__image {
    background-size: contain!important;
  }

  .content {
    width: 100%;
    height: 100%;
    position: relative;
    .control {
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
</style>

<style lang="scss" module>
.FcmGalleryDialogContent {
  background-color: var(--v-modalBg-base);
}
</style>



















